import * as React from 'react';

import {Button} from 'shells/button/button';
import {getCrmLogoFromType, getImportTypeFromCrmType} from 'shells/import2/helpers';
import {Body} from 'shells/typography/body';

import styles from './crm-row.module.css';

type Props = {
    label: string;
    type: string;
    onInitiateImport: () => void;
};

export function CrmRow(props: Props) {
    const imgSrc = getCrmLogoFromType(props.type);
    const subtitle = `Import your ${getImportTypeFromCrmType(props.type)} from ${props.label}`;

    return (
        <div className={styles.row}>
            <div className='full-height flex'>
                <img src={imgSrc} alt={props.label} className={styles.image} />
                <div className='flex flex-dir-col justify-center'>
                    <Body isBold={true}>{props.label}</Body>
                    <Body>{subtitle}</Body>
                </div>
            </div>
            <div className='mr-8'>
                <Button onClick={props.onInitiateImport} variant='primary' size='big'>
                    Start
                </Button>
            </div>
        </div>
    );
}
